module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/default_news_bg_big.a46ac225.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/components/AnnouncementsCard/images/default_news_bg_big.jpg
// module id = 2892
// module chunks = 11